import axios from '../axios.js'

var project = {
    // 获取我的项目工作量列表
    getProjectWorkTimes: function (data, success, failure) {
        return axios.get('/resource/getProjectWorkTimes', data, success, failure)
    },
    // 我的项目
    getMyProjectInfos: function (data, success, failure) {
        return axios.get('/project/getMyProjectInfos', data, success, failure)
    },
    // 获取全部项目列表
    getProjects: function (data, success, failure) {
        return axios.get('/project/getProjects', data, success, failure)
    },
    // 获取投资组合列表
    getProjectPortfolios: function (data, success, failure) {
        return axios.get('/portfolio/getProjectPortfolios', data, success, failure)
    },
    // 获取投资组合列表（只包含第二级以下）
    getProjPortfolios: function (data, success, failure) {
        return axios.get('/portfolio/getProjPortfolios', data, success, failure)
    },
    // 获取项目过程列表
    getProjectProcesses: function (data, success, failure) {
        return axios.get('/process/getProjectProcesses', data, success, failure)
    },
    // 添加/修改项目
    saveProjectInfo: function (data, success, failure) {
        return axios.postJson('/project/saveProjectInfo', data, success, failure)
    },
    // 查看项目信息
    getProjectInfo: function (data, success, failure) {
        return axios.get('/project/getProjectInfo', data, success, failure)
    },
    // 查看项目费用
    getProjectCosts: function (data, success, failure) {
        return axios.get('/cost/getProjectCosts', data, success, failure)
    },

    // 查看项目预估成本
    getProjectCost: function (data, success, failure) {
        return axios.get('/cost/getProjectCost', data, success, failure)
    },
    // 添加修改物资成本
    saveProjectCost: function (data, success, failure) {
        return axios.postJson('/cost/saveProjectCost', data, success, failure)
    },
    // 删除物资成本
    deleteProjectCost: function (data, success, failure) {
        return axios.post('/cost/deleteProjectCost', data, success, failure)
    },
    // 获取项目里程碑
    milestonegetProjectMilestones: function (data, success, failure) {
        return axios.get('/milestone/getProjectMilestones', data, success, failure)
    },
    // 修改里程碑时间
    update: function (data, success, failure) {
        return axios.postJson('/milestone/update', data, success, failure)
    },
    // 完成里程碑一项
    complete: function (data, success, failure) {
        return axios.post('/milestone/complete', data, success, failure)
    },
    // 获取项目状态
    statusgetProjectStatus: function (data, success, failure) {
        return axios.get('/status/getProjectStatus', data, success, failure)
    },
    // 更新项目状态
    updateProjectStatus: function (data, success, failure) {
        return axios.postJson('/status/updateProjectStatus', data, success, failure)
    },
    // 获取项目资源列表
    projectResourcegetProjectResources: function (data, success, failure) {
        return axios.get('/projectResource/getProjectResources', data, success, failure)
    },
    // 获取项目资源更改列表
    getUpdateResources: function (data, success, failure) {
        return axios.get('/projectResource/getUpdateResources', data, success, failure)
    },
    // 修改项目资源
    updateProjectResources: function (data, success, failure) {
        return axios.postJson('/projectResource/updateProjectResources', data, success, failure)
    },
    // 项目列表
    getProjectInfoLists: function (data, success, failure) {
        return axios.get('/project/getProjectInfoList', data, success, failure)
    },
    // 项目归档/取消归档
    archiveProject: function (data, success, failure) {
        return axios.post('/project/archiveProject', data, success, failure)
    },
    // 获取资源图数据
    getResourceImg: function (data, success, failure) {
        return axios.get('/resourceImg/getResourceImg', data, success, failure)
    },
    // 获取资源图数据
    getProjectResourceImg: function (data, success, failure) {
        return axios.get('/resourceImg/getProjectResourceImg', data, success, failure)
    },
    getUserProjectInfoPageVOs: function (data, success, failure) {
        return axios.get('/project/getUserProjectInfoPageVOs', data, success, failure)
    },
    // 获取用户项目列表
    getUserProjectInfoVOs: function (data, success, failure) {
        return axios.get('/project/getUserProjectInfoVOs', data, success, failure)
    },
    // 检查是否有项目操作权限
    checkProjectOperate: function (data, success, failure) {
        return axios.get('/project/checkProjectOperate', data, success, failure)
    },
    // 获取项目管理者
    getProjectManager: function (data, success, failure) {
        return axios.get('/project/getProjectManager', data, success, failure)
    },
    // 设置项目管理者
    setProjectManager: function (data, success, failure) {
        return axios.post('/project/setProjectManager', data, success, failure)
    },
    // 获取我的筛选项目列表
    getSelectProjectInfos: function (data, success, failure) {
        return axios.get('/project/getSelectProjectInfos', data, success, failure)
    },

    // 获取项目看板大屏数据
    getProjectViewBoards: function (data, success, failure) {
        return axios.get('/project/getProjectViewBoards', data, success, failure);
    },

    // 创建会议
    addMeeting: function (data, success, failure) {
        return axios.postJson('/meeting/addMeeting', data, success, failure)
    },

    // 获取会议数据
    getMeetings: function (data, success, failure) {
        return axios.get('/meeting/getMeetings', data, success, failure);
    },
    // 获取会议详情
    getMeetingInfo: function (data, success, failure) {
        return axios.get('/meeting/getMeetingInfo', data, success, failure);
    },

    //修改会议内容
    updateMeeting: function (data, success, failure) {
        return axios.post('/meeting/updateMeeting', data, success, failure)
    },

    //修改会议成员
    updateMeetingEmployees: function (data, success, failure) {
        return axios.post('/meeting/updateMeetingEmployees', data, success, failure)
    },

    // 获取会议时间线
    getMeetingTimeLines: function (data, success, failure) {
        return axios.get('/meeting/getMeetingTimeLines', data, success, failure);
    },
    // 获取会议列表（时间线）
    getTimeLineMeetings: function (data, success, failure) {
        return axios.get('/meeting/getTimeLineMeetings', data, success, failure);
    },

    //
    //
    //
    //
    // 项目接口v2
    //
    //
    //
    //

    //获取项目信息
    getProjectBaseInfo: function (data, success, failure) {
        return axios.get('/v2/project/getProjectBaseInfo', data, success, failure);
    },
    //修改项目负责人
    changeProjectManager: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectManager', data, success, failure);
    },
    //修改项目开始时间
    changeProjectDate: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectDate', data, success, failure);
    },
    //修改项目状态
    projectchangeProjectStatus: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectStatus', data, success, failure);
    },
    //项目类型查询
    getProjectTypeSelects: function (data, success, failure) {
        return axios.get('/v2/project/getProjectTypeSelects', data, success, failure);
    },

    //修改项目类型
    changeProjectTypes: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectTypes', data, success, failure);
    },
    //修改项目类型
    changeProjectArchive: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectArchive', data, success, failure);
    },
    //修改项目描述
    changeProjectDescription: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectDescription', data, success, failure);
    },
    //修改客户信息
    changeProjectCustomer: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectCustomer', data, success, failure);
    },
    //获取项目分类列表
    getModuleMilestoneCompanies: function (data, success, failure) {
        return axios.get('/v2/projectMilestone/getModuleMilestoneCompanies', data, success, failure);
    },

    //新增项目2
    createProject2: function (data, success, failure) {
        return axios.postJson('/v2/project/createProject2', data, success, failure);
    },
    //获取项目里程碑列表
    getProjectMilestones: function (data, success, failure) {
        return axios.get('/v2/projectMilestone/getProjectMilestones', data, success, failure);
    },
    //获取项目里程碑操作记录
    getProjectMilestoneHistories: function (data, success, failure) {
        return axios.get('/v2/projectMilestone/getProjectMilestoneHistories', data, success, failure);
    },
    //修改项目里程碑时间
    changeMilestoneDate: function (data, success, failure) {
        return axios.post('/v2/projectMilestone/changeMilestoneDate', data, success, failure);
    },
    //修改项目里程碑时间
    changeMilestoneRealDate: function (data, success, failure) {
        return axios.post('/v2/projectMilestone/changeMilestoneRealDate', data, success, failure);
    },
    //修改项目里程碑状态
    deleteMilestone: function (data, success, failure) { return axios.post('/v2/projectMilestone/deleteMilestone', data, success, failure); },
    restoreMilestone: function (data, success, failure) { return axios.post('/v2/projectMilestone/restoreMilestone', data, success, failure); },
    getDeletedMilestones: function (data, success, failure) { return axios.get('/v2/projectMilestone/getDeletedMilestones', data, success, failure); },
    changeMilestoneStatus: function (data, success, failure) {
        return axios.post('/v2/projectMilestone/changeMilestoneStatus', data, success, failure);
    },
    //修改项目里程碑进度
    changeMilestoneProgress: function (data, success, failure) {
        return axios.post('/v2/projectMilestone/changeMilestoneProgress', data, success, failure);
    },
    //获取项目资源记录
    getProjectResources: function (data, success, failure) {
        return axios.get('/v2/projectResource/getProjectResources', data, success, failure);
    },
    //获取项目资源模板记录
    getProjectResourceRoles: function (data, success, failure) {
        return axios.get('/v2/projectResource/getProjectResourceRoles', data, success, failure);
    },
    //获取项目资源模板记录
    getModuleResourceCompanies: function (data, success, failure) {
        return axios.get('/v2/projectResource/getModuleResourceCompanies', data, success, failure);
    },
    //新增项目资源
    addProjectResource: function (data, success, failure) {
        return axios.postJson('/v2/projectResource/addProjectResource', data, success, failure);
    },
    //新增项目资源
    updateProjectResource: function (data, success, failure) {
        return axios.postJson('/v2/projectResource/updateProjectResource', data, success, failure);
    },

    //项目列表
    getMyProject: function (data, success, failure) {
        return axios.get('/v2/project/getMyProject', data, success, failure);
    },
    //项目列表资源历史
    getProjectResourceHistories: function (data, success, failure) {
        return axios.get('/v2/projectResource/getProjectResourceHistories', data, success, failure);
    },
    //项目状态列表
    getProjectStatus: function (data, success, failure) {
        return axios.get('/v2/projectStatus/getProjectStatus', data, success, failure);
    },
    //项目状态历史列表
    getProjectStatusHistories: function (data, success, failure) {
        return axios.get('/v2/projectStatus/getProjectStatusHistories', data, success, failure);
    },
    //项目状态选择列表
    getModuleStatusCompanies: function (data, success, failure) {
        return axios.get('/v2/projectStatus/getModuleStatusCompanies', data, success, failure);
    },
    //修改项目状态
    changeProjectStatus: function (data, success, failure) {
        return axios.postJson('/v2/projectStatus/changeProjectStatus', data, success, failure);
    },
    //修改项目状态
    addMeeting2: function (data, success, failure) {
        return axios.postJson('/v2/meeting/addMeeting', data, success, failure);
    },
    //会议室选择列表
    getCompanyMeetingRooms: function (data, success, failure) {
        return axios.get('/v2/meeting/getCompanyMeetingRooms', data, success, failure);
    },
    //会议室选择列表
    v2getMeetings: function (data, success, failure) {
        return axios.get('/v2/meeting/getMeetings', data, success, failure);
    },
    //会议详情
    v2getMeetingInfo: function (data, success, failure) {
        return axios.get('/v2/meeting/getMeetingInfo', data, success, failure);
    },
    //删除会议
    v2deleteMeeting: function (data, success, failure) {
        return axios.post('/v2/meeting/deleteMeeting', data, success, failure);
    },
    //修改会议成员
    v2updateMeetingEmployees: function (data, success, failure) {
        return axios.post('/v2/meeting/updateMeetingEmployees', data, success, failure);
    },
    //修改会议内容
    v2updateMeeting: function (data, success, failure) {
        return axios.post('/v2/meeting/updateMeeting', data, success, failure);
    },
    //会议详情
    v2getProjectCost: function (data, success, failure) {
        return axios.get('/v2/projectCost/getProjectCost', data, success, failure);
    },
    //获取项目物资成本列表
    v2getProjectCosts: function (data, success, failure) {
        return axios.get('/v2/projectCost/getProjectCosts', data, success, failure);
    },
    //获取项目物资成本列表（分页）
    getPageProjectCosts: function (data, success, failure) {
        return axios.get('/v2/projectCost/getPageProjectCosts', data, success, failure);
    },
    //添加修改物资成本
    v2saveProjectCost: function (data, success, failure) {
        return axios.postJson('/v2/projectCost/saveProjectCost', data, success, failure);
    },
    //添加修改物资成本
    v2deleteProjectCost: function (data, success, failure) {
        return axios.post('/v2/projectCost/deleteProjectCost', data, success, failure);
    },
    //获取项目活动记录
    v2getProjectOperateLogs: function (data, success, failure) {
        return axios.get('/v2/projectActive/getProjectOperateLogs', data, success, failure);
    },
    //获取项目里程碑进度
    v2getProjectMilestoneProgress: function (data, success, failure) {
        return axios.get('/v2/projectStatistics/getProjectMilestoneProgress', data, success, failure);
    },
    //获取项目实际和预估进度
    v2getProjectRealAndExpectedProgress: function (data, success, failure) {
        return axios.get('/v2/projectStatistics/getProjectRealAndExpectedProgress', data, success, failure);
    },
    //获取项目实际和预估进度
    v2getProjectTaskSituation: function (data, success, failure) {
        return axios.get('/v2/projectStatistics/getProjectTaskSituation', data, success, failure);
    },
    //获取项目实际和预估进度
    v2getProjectEmployeeTaskSituation: function (data, success, failure) {
        return axios.get('/v2/projectStatistics/getProjectEmployeeTaskSituation', data, success, failure);
    },
    //获取项目实际和预估进度
    v2getProjectTaskDayNewAndFinishNum: function (data, success, failure) {
        return axios.get('/dashboard/companyProject/getProjectTaskDayNewAndFinishNum', { projectId: data.pId, size: 20 }, success, failure);
    },
    //获取项目实际和预估进度
    v2getProjectTaskBoards: function (data, success, failure) {
        return axios.get('/v2/projectTaskBoard/getProjectTaskBoards', data, success, failure);
    },
    //修改项目面板
    v2saveTaskBoard: function (data, success, failure) {
        return axios.postJson('/v2/projectTaskBoard/saveTaskBoard', data, success, failure);
    },
    //修改项目泳道
    v2saveTaskLane: function (data, success, failure) {
        return axios.postJson('/v2/task/saveTaskLane', data, success, failure);
    },
    //删除项目泳道
    v2deleteTaskLane: function (data, success, failure) {
        return axios.post('/v2/task/deleteTaskLane', data, success, failure);
    },

    //根据任务面板id获取任务泳道列表
    v2getTaskLanesByTaskBoardID: function (data, success, failure) {
        return axios.get('/v2/taskBoardDetail/getTaskLanesByTaskBoardID', data, success, failure);
    },
    //根据任务泳道id获取任务清单
    v2getTaskListsByTaskLaneId: function (data, success, failure) {
        return axios.get('/v2/taskBoardDetail/getTaskListsByTaskLaneId', data, success, failure);
    },
    //根据任务泳道id获取任务清单及任务列表
    getGanttTasksByTaskLaneId: function (data, success, failure) {
        return axios.get('/v2/taskBoardDetail/getGanttTasksByTaskLaneId', data, success, failure);
    },
    v2getTaskListsAndTasksByTaskLaneId: function (data, success, failure) {
        return axios.get('/v2/taskBoardDetail/getTaskListsAndTasksByTaskLaneId', data, success, failure);
    },
    //根据任务泳道id获取任务清单及任务列表
    v2getCompanyEmployees: function (data, success, failure) {
        return axios.get('/v2/employee/getCompanyEmployees', data, success, failure);
    },
    //修改项目清单
    v2saveTaskBoardChildList: function (data, success, failure) {
        return axios.postJson('/v2/task/saveTaskBoardChildList', data, success, failure);
    },
    //删除项目清单
    v2deleteTaskBoardChild: function (data, success, failure) {
        return axios.post('/v2/task/deleteTaskBoardChild', data, success, failure);
    },
    //添加任务
    v2addTask: function (data, success, failure) {
        return axios.postJson('/v2/task/addTask', data, success, failure);
    },
    //添加任务
    getMyOrAllProjects: function (data, success, failure) {
        return axios.get('/v2/project/getMyOrAllProjects', data, success, failure);
    },
    //添加任务
    v2getTaskBoards: function (data, success, failure) {
        return axios.get('/v2/task/getTaskBoards', data, success, failure);
    },
    //拖拽任务
    v2updateTaskStartAndEndTime: function (data, success, failure) {
        return axios.post('/v2/task/updateTaskStartAndEndTime', data, success, failure);
    },
    //任务面板列表显示
    v2getTaskBoardTasks: function (data, success, failure) {
        return axios.get('/v2/taskBoardDetail/getTaskBoardTasks', data, success, failure);
    },
    //获取全部项目信息
    v2getCompanyProject: function (data, success, failure) {
        return axios.get('/v2/project/getCompanyProject', data, success, failure);
    },
    //获取全部项目信息
    v2getMyOrCompanyProjects: function (data, success, failure) {
        return axios.get('/v2/project/getMyOrCompanyProjects', data, success, failure);
    },

    //添加删除审核人
    v2saveTaskApprove: function (data, success, failure) {
        return axios.post('/v2/task/saveTaskApprove', data, success, failure);
    },
    //获取项目审核人列表
    v2getTaskApproves: function (data, success, failure) {
        return axios.get('/v2/task/getTaskApproves', data, success, failure);
    },
    //审核人顺序
    v2sortTaskApproves: function (data, success, failure) {
        return axios.postJson('/v2/task/sortTaskApproves', data, success, failure);
    },
    //确定审核人
    v2confirmApprove: function (data, success, failure) {
        return axios.post('/v2/task/confirmApprove', data, success, failure);
    },
    //审核任务
    v2approveTask: function (data, success, failure) {
        return axios.post('/v2/task/approveTask', data, success, failure);
    },
    //待审核任务列表
    v2getMyApproveTasks: function (data, success, failure) {
        return axios.get('/v2/task/getMyApproveTasks', data, success, failure);
    },
    //管理后台审核流程
    v2setCompanyCheckConfig: function (data, success, failure) {
        return axios.postJson('/v2/companyCheckConfig/setCompanyCheckConfig', data, success, failure);
    },
    //管理后台审核流程
    v2getCompanyCheckConfigs: function (data, success, failure) {
        return axios.get('/v2/companyCheckConfig/getCompanyCheckConfigs', data, success, failure);
    },
    //按钮权限
    v2checkIsCanOperate: function (data, success, failure) {
        return axios.post('/v2/project/checkIsCanOperate', data, success, failure);
    },
    //修改项目投资组合
    v2changeProjectPortfolios: function (data, success, failure) {
        return axios.post('/v2/project/changeProjectPortfolios', data, success, failure);
    },
    //加班列表
    getMyEmployeeOvertimes: function (data, success, failure) {
        return axios.get('/v2/employeeOvertime/getMyEmployeeOvertimes', data, success, failure);
    },
    //加班申请
    addEmployeeOvertime: function (data, success, failure) {
        return axios.postJson('/v2/employeeOvertime/addEmployeeOvertime', data, success, failure);
    },
    //加班取消
    cancelEmployeeOvertime: function (data, success, failure) {
        return axios.post('/v2/employeeOvertime/cancelEmployeeOvertime', data, success, failure);
    },
    //报销列表
    getMyExpenses: function (data, success, failure) {
        return axios.get('/v2/employeeExpenses/getMyExpenses', data, success, failure);
    },
    //报销申请
    saveEmployeeExpense: function (data, success, failure) {
        return axios.postJson('/v2/employeeExpenses/saveEmployeeExpense', data, success, failure);
    },
    //报销取消
    cancelEmployeeExpense: function (data, success, failure) {
        return axios.post('/v2/employeeExpenses/cancelEmployeeExpense', data, success, failure);
    },
    //报销发放确认
    confirmPayExpenses: function (data, success, failure) {
        return axios.post('/v2/employeeExpenses/confirmPayExpenses', data, success, failure);
    },
    // 报销类型列表
    getExpensesTypes: function (data, success, failure) {
        return axios.get('/v2/employeeExpenses/getExpensesTypes', data, success, failure);
    },

    //请假列表
    getMyAskForLeaves: function (data, success, failure) {
        return axios.get('/v2/employeeAskForLeave/getMyAskForLeaves', data, success, failure);
    },
    //请假申请
    saveEmployeeAskForLeave: function (data, success, failure) {
        return axios.postJson('/v2/employeeAskForLeave/saveEmployeeAskForLeave', data, success, failure);
    },
    //请假取消
    cancelAskForLeave: function (data, success, failure) {
        return axios.post('/v2/employeeAskForLeave/cancelAskForLeave', data, success, failure);
    },

    //修改密码
    v2updatePassword: function (data, success, failure) {
        return axios.post('/v2/employee/updatePassword', data, success, failure);
    },
    //验证原手机号
    v2checkOldMobile: function (data, success, failure) {
        return axios.post('/v2/employee/checkOldMobile', data, success, failure);
    },
    //修改手机号
    v2updateMobile: function (data, success, failure) {
        return axios.post('/v2/employee/updateMobile', data, success, failure);
    },
    //修改头像
    v2updateEmployeeFace: function (data, success, failure) {
        return axios.post('/v2/employee/updateEmployeeFace', data, success, failure);
    },
    //修改名称
    v2updateEmployeeName: function (data, success, failure) {
        return axios.post('/v2/employee/updateEmployeeName', data, success, failure);
    },
    //修改邮箱
    v2updateEmail: function (data, success, failure) {
        return axios.post('/v2/employee/updateEmail', data, success, failure);
    },
    getCompanyCurrentMonthWorkHours: function (data, success, failure) {
        return axios.get("/v2/companyHoliday/getCompanyCurrentMonthWorkHours", data, success, failure);
    },

    saveHolidays: function (data, success, failure) {
        return axios.postJson("/v2/companyHoliday/saveHolidays", data, success, failure);
    },
    getMyMonthDayTaskCount: function (data, success, failure) {
        return axios.post("/v2/task/getMyMonthDayTaskCount", data, success, failure);
    },
    getCompanyMeetingRoomPages: function (data, success, failure) {
        return axios.get("/v2/companyCheckConfig/getCompanyMeetingRooms", data, success, failure);
    },
    saveCompanyMeetingRoom: function (data, success, failure) {
        return axios.postJson("/v2/companyCheckConfig/saveCompanyMeetingRoom", data, success, failure);
    },
    deleteCompanyMeetingRoom: function (data, success, failure) {
        return axios.post("/v2/companyCheckConfig/deleteCompanyMeetingRoom", data, success, failure);
    },
    getEmployeeAllCompanys: function (data, success, failure) {
        return axios.get("/v2/employee/getEmployeeAllCompanys", data, success, failure);
    },
    //离职
    v2deleteEmployee: function (data, success, failure) {
        return axios.post("/employeeManage/deleteEmployee", data, success, failure);
    },
    //修改项目kpi
    v2changeProjectKpi: function (data, success, failure) {
        return axios.post("/v2/project/changeProjectKpi", data, success, failure);
    },
    //修改项目说明
    v2changeProjectRemark: function (data, success, failure) {
        return axios.post("/v2/project/changeProjectRemark", data, success, failure);
    },
    //
    v2inviteMember: function (data, success, failure) {
        return axios.postJson("/employeeManageV2/inviteMember", data, success, failure);
    },
    //
    checkLink: function (data, success, failure) {
        return axios.post("/v2/employee/checkLink", data, success, failure);
    },
    //
    v2deleteProjectResource: function (data, success, failure) {
        return axios.post("/v2/projectResource/deleteProjectResource", data, success, failure);
    },
    v2changeTaskCheckItemStatus: function (data, success, failure) {
        return axios.post("/v2/task/changeTaskCheckItemStatus", data, success, failure);
    },
    getSysVersion: function (data, success, failure) {
        return axios.get("/sysVersion/getSysVersion", data, success, failure);
    },
    getDefaultCompanyWorkHours: function (data, success, failure) {
        return axios.get("/v2/companyWorkHours/getDefaultCompanyWorkHours", data, success, failure);
    },

    repeatSendInvite: function (data, success, failure) {
        return axios.post("/employeeManageV2/repeatSendInvite", data, success, failure);
    },
    submitTaskApprove: function (data, success, failure) {
        return axios.post("/v2/task/submitTaskApprove", data, success, failure);
    },
    getTaskApproveHistories: function (data, success, failure) {
        return axios.get("/v2/task/getTaskApproveHistories", data, success, failure);
    },
    //添加评论
    addTaskCheckItemComment: function (data, success, failure) {
        return axios.postJson("/v2/taskCheckItemComment/addTaskCheckItemComment", data, success, failure);
    },
    //评论列表
    getTaskCheckItemComments: function (data, success, failure) {
        return axios.get("/v2/taskCheckItemComment/getTaskCheckItemComments", data, success, failure);
    },
    //评论列表
    getTaskCheckItemComments2: function (data, success, failure) {
        return axios.get("/v2/taskCheckItemComment/getTaskCheckItemComments", data, success, failure);
    },
    //评论列表
    getTasksByTaskListId: function (data, success, failure) {
        return axios.get("/v2/taskBoardDetail/getTasksByTaskListId", data, success, failure);
    },
    //帮助中心
    getHelps: function (data, success, failure) {
        return axios.get("/v2/help/getHelps", data, success, failure);
    },
    //修改用户邮箱
    v2checkOldEmail: function (data, success, failure) {
        return axios.post("/v2/employee/checkOldEmail", data, success, failure);
    },
    // 反馈
    addSuggest: function (data, success, failure) {
        return axios.post("/v2/suggest/addSuggest", data, success, failure);
    },

    // 反馈
    getProjectFiles: function (data, success, failure) {
        return axios.get("/v2/projectFile/getProjectFiles", data, success, failure);
    },
    // 保存文件
    saveProjectFile: function (data, success, failure) {
        return axios.postJson("/v2/projectFile/saveProjectFile", data, success, failure);
    },
    // 删除文件
    deleteProjectFile: function (data, success, failure) {
        return axios.post("/v2/projectFile/deleteProjectFile", data, success, failure);
    },
    // 创建项目报表
    createProjectReport: function (data, success, failure) {
        return axios.postJson("/v2/report/createProjectReport", data, success, failure);
    },
    // 创建资源报表
    createResourceReport: function (data, success, failure) {
        return axios.postJson("/v2/report/createResourceReport", data, success, failure);
    },
    // 获取报表详情
    getReportByUuid: function (data, success, failure) {
        return axios.get("/v2/report/getReportByUuid", data, success, failure);
    },
    // 获取报表列表
    getReports: function (data, success, failure) {
        return axios.get("/v2/report/getReports", data, success, failure);
    },
    // 删除资源报表
    deleteReport: function (data, success, failure) {
        return axios.post("/v2/report/deleteReport", data, success, failure);
    },
    // 修改资源报表
    updateReport: function (data, success, failure) {
        return axios.post("/v2/report/updateReport", data, success, failure);
    },

    // 获取资源时段内任务列表
    getReportResourceTasks: function (data, success, failure) {
        return axios.get("/v2/report/getReportResourceTasks", data, success, failure);
    },

    /**
     * 添加任务关联
     */
    addTaskRelation: function (data, success, failure) {
        return axios.postJson("/v2/task/addTaskRelation", data, success, failure);
    },

    /**
     * 删除任务关联
     */
    deleteTaskRelation: function (data, success, failure) {
        return axios.postJson("/v2/task/deleteTaskRelation", data, success, failure);
    },

    /**
     * 获取任务关联列表
     */
    getRelationTasks: function (data, success, failure) {
        return axios.get("/v2/task/getRelationTasks", data, success, failure);
    },

    /**
     * 获取项目任务关联列表
     */
    getProjectTaskRelations: function (data, success, failure) {
        return axios.get("/v2/task/getProjectTaskRelations", data, success, failure);
    },

    /**
     * 获取项目附件列表
     */
    getProjectAttachments: function (data, success, failure) {
        return axios.get("/v2/project/getProjectAttachments", data, success, failure);
    },
    //获取所有的项目和里程碑
    getAllProjectAboutGantt: function (data, success, failure) {
        return axios.get("/v2/project/getProjectGantts", data, success, failure);
    },

}

export default project
